import { PaginatedResponse } from '@synergy/api';
import { createReducer } from '@reduxjs/toolkit';

import { BonusSettlement } from '../../models/bonus-settlement';
import { fetchBonusSettlements, resetBonusSettlementsState } from './bonus-settlements-overview-actions';

export interface BonusSettlementsOverviewReducerState {
    bonusSettlements: PaginatedResponse<BonusSettlement>;
    requesting: boolean;
}

export const initialBonusSettlementsOverviewReducerState: BonusSettlementsOverviewReducerState = {
    bonusSettlements: { items: [], total: 0, limit: 10, page: 0 },
    requesting: false,
};

export const bonusSettlementsOverviewReducer = createReducer(initialBonusSettlementsOverviewReducerState, builder => {
    builder.addCase(fetchBonusSettlements.pending, state => {
        state.requesting = true;
    });
    builder.addCase(fetchBonusSettlements.fulfilled, (state, action) => {
        state.bonusSettlements = action.payload;
        state.requesting = false;
    });
    builder.addCase(fetchBonusSettlements.rejected, state => {
        state.requesting = false;
    });
    builder.addCase(resetBonusSettlementsState, () => initialBonusSettlementsOverviewReducerState);
});
